import {
  isDspSource,
  isDbpSource,
  getOrderSourceLabel,
  ORDER_SOURCE_DSP,
  ORDER_SOURCE_DBP,
} from '../../DeliveryOrders/constants/orderSource'

export { isDspSource, isDbpSource, ORDER_SOURCE_DSP, ORDER_SOURCE_DBP }

// The value is what the API filters on, so it stays 'DSP'; only the option text is
// relabelled, matching the pill in the table and on the order details page.
export const ORDER_DETAIL_SOURCES = [
  { text: getOrderSourceLabel(ORDER_SOURCE_DSP), value: ORDER_SOURCE_DSP },
  { text: getOrderSourceLabel(ORDER_SOURCE_DBP), value: ORDER_SOURCE_DBP },
]

export const getPickingOrderSourceClassName = (source) => {
  if (!source) {
    return 'picking-order-source'
  }
  return `picking-order-source picking-order-source--${String(source).toLowerCase()}`
}
